import SheduleManageContainer from './SheduleManage.container'

export default SheduleManageContainer